import React from "react"
import "../styles/cursor.css"

export default function cCursor() {
    return <span class="blinking-cursor"> &nbsp;_ </span>
}
